import React from 'react'
import TabComponent from '../../components-new/common/TabComponent'
import { DeveloperModeOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { PageTitle } from '../../components-new/common';
import MobileConfiguration from '../Mobile/MobileConfiguration';


const Settings = () => {
    const tabs = [
    {
      icon: <DeveloperModeOutlined />,
      label: "Mobile Configuration",
      content: <MobileConfiguration />,
    },

  ];
  return (
       <Box sx={{ py: 4 }}>
      <div className="flex flex-row items-center justify-between w-full mb-2">
        <PageTitle title="Settings" />
      </div>
      <TabComponent tabs={tabs} />
    </Box>
  )
}

export default Settings